import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.function.name.js";
import React, { useState, useCallback } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { useDropzone } from 'react-dropzone';
import Text from 'components/Text';
import TextLink from 'components/TextLink';
import DropIndicator from 'components/DropIndicator';
import { setAlert } from 'actions/alerts';
var OpenLink = function OpenLink(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(TextLink, {
    as: "span"
  }, children);
};
function SubtitlesUploader(_ref2) {
  var onSelect = _ref2.onSelect;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    file = _useState2[0],
    setFile = _useState2[1];
  var selectFile = useCallback(function (acceptedFiles, rejectedFiles) {
    if (rejectedFiles.length) {
      setAlert({
        title: t('error_subtitles_vtt_format')
      });
      return;
    }
    if (acceptedFiles.length) {
      var _acceptedFiles = _slicedToArray(acceptedFiles, 1),
        selectedFile = _acceptedFiles[0];
      setFile(selectedFile);
      onSelect(selectedFile);
    }
  }, [onSelect, t]);
  var _useDropzone = useDropzone({
      multiple: false,
      accept: '.vtt',
      onDrop: selectFile
    }),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps,
    isDragActive = _useDropzone.isDragActive,
    isDragReject = _useDropzone.isDragReject;
  return /*#__PURE__*/React.createElement("div", getRootProps(), /*#__PURE__*/React.createElement(Text, {
    as: "div",
    size: "s"
  }, /*#__PURE__*/React.createElement("input", getInputProps()), /*#__PURE__*/React.createElement(DropIndicator, {
    textAlign: "center",
    p: "xs",
    isDragActive: isDragActive,
    isDragReject: isDragReject
  }, isDragActive && t('subtitles_file_drop_to_upload'), !isDragActive && file && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    as: "p"
  }, file.name), /*#__PURE__*/React.createElement(Trans, {
    t: t,
    i18nKey: "subtitles_drop_and_replace"
  }, /*#__PURE__*/React.createElement(OpenLink, null, "Click"), " or drag and drop to replace")), !isDragActive && !file && /*#__PURE__*/React.createElement(Trans, {
    t: t,
    i18nKey: "subtitles_drop_and_upload"
  }, /*#__PURE__*/React.createElement(OpenLink, null, "Click"), " or drag and drop to upload subtitles (file format .vtt)."))));
}
export default SubtitlesUploader;